<template>
    <transition>
        <div class="cardBillDetail" v-loading="fullscreenLoading">
            <span class="card-icon">
                <!-- 写号推送按钮 -->
                <el-button
                    v-if="showWriteCardButton"
                    type="primary"
                    size="small"
                    class="themed-button write-card-btn"
                    @click="handleWriteCardPush"
                    style="margin-right: 10px"
                >
                    写号推送
                </el-button>
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="refreshLiuliang"
                    v-preventReClick="2000"
                    style="margin-right: 10px"
                    >刷新流量</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="refresh(true)"
                    style="margin-right: 10px"
                    >获取实时状态</el-button
                >
                <i class="el-icon-refresh-right" @click="refresh"></i>
            </span>
            <!-- <div class="group">
        <h1 class="title">基本信息</h1>
        <div>
          <table cellspacing="0" cellpadding="0" style="width: 100%">
            <tr>
              <td>ICCID</td>
              <td>{{ iccidMark }}</td>
              <td>套餐类型</td>
              <td>{{ data.mealTypeStr }}</td>
              <td>套餐总流量</td>
              <td>{{totalFlowId}}</td>
            </tr>
            <tr>
              <td>接入号</td>
              <td>{{ data.phone }}</td>
              <td>基础套餐</td>
              <td>{{ data.setMealName }}</td>
              <td>过期时间</td>
              <td>{{ data.expireDate }}</td>
            </tr>
            <tr>
              <td>运营商</td>
              <td>{{ data.accountName }}</td>
              <td>网卡状态</td>
              <td>{{data.statusString}}</td>
              <td>已使用流量</td>
              <td>{{ parseFloat(data.totalBytesCnt).toFixed(2)}}MB</td>
            </tr>
            <tr>
              <td>卡类型</td>
              <td>
                <span v-if="data.type == 1">包月</span>
                <span v-else>包年</span>
              </td>
              <td>供应商</td>
              <td>{{ accountEntity.supplier }}</td>
              <td>
                <span v-if="!data.invNo">剩余流量</span>
              </td>
              <td>
                <span v-if="!data.invNo">{{surplusFlowId}}</span>
              </td>
            </tr>
            <tr>
              <td>导入时间</td>
              <td>{{ importTime }}</td>
              <td>手机绑定</td>
              <td>
                <span v-if="res.phonebind">{{ res.phonebind }}</span>
                <span v-else>未绑定</span>
              </td>
              <td>增加已使用流量百分比<span v-if="res.strategyType==1"> (A)</span><span v-else-if="res.strategyType==2"> (B)</span></td>
              <td>
                <span v-html="curStrategyFormat"></span>
              </td>
            </tr>
            <tr>
              <td>激活时间</td>
              <td>{{ data.servCreateDate }}</td>
              <td>流量池子</td>
              <td>{{ accountEntity.flowPool }}</td>
              <td>已使用流量（真）</td>
              <td>{{ parseFloat(data.orginTotalBytesCnt).toFixed(2) }}MB</td>
            </tr>
            <tr>
              <td>当前套餐</td>
              <td v-html="currentMeal"></td>
              <td>代理商</td>
              <td>
                <span v-if="data.agentName">{{ data.agentThreeName }}</span>
                <span v-else>未分配</span>
              </td>
              <td>生效时间</td>
              <td>{{ res.takeEffectTime }}</td>
            </tr>
            <tr id="yuyin1" v-if="isShow">
              <td>总语音分钟</td>
              <td><span>{{data.voiceSize}}分钟</span></td>
              <td>已使用语音分钟</td>
              <td><span>{{voiceUsed}}</span></td>
              <td>已使用语音分钟(真)</td>
              <td><span>{{origVoiceUsed}}</span></td>
            </tr>
            <tr id="yuyin2" v-if="isShow">
                <td>剩余语音分钟</td>
                <td><span>{{voiceRemaining}}</span></td>
                <td>增加语音百分比</td>
                <td>
                  <span v-if="res.voiceAddDiscount">{{res.voiceAddDiscount}}</span>
                  <span v-else>未设置</span>
                </td>
                <td>运营商状态</td>
                <td>{{yunyingstatusspan}}</td>
            </tr>
            <tr>
              <td>当前限速值</td>
              <td>{{ res.limitSpeed }}</td>
              <td>IMEI</td>
              <td>{{ data.imei }}</td>
              <td>
                <span v-if="data.toType == _getToTypeValue('Y_')">话费</span>
                <span v-else></span>
              </td>
              <td>
                <span v-if="data.toType == _getToTypeValue('Y_')">{{data.balanceMoney}}</span>
                <span v-else></span>
              </td>
            </tr>
            <tr>
              <td>实名状态</td>
              <td>
                  <span v-if="isReal == 1">已实名</span>
                  <span v-else-if="isReal == 2">未实名</span>
                  <span v-else>—未知状态—</span>
                  <i class="el-icon-refresh-right" @click="_isRealName"></i>
              </td>
              <td>
                <span v-if="data.invNo">虚拟号</span>
              </td>
              <td>
                <span v-if="data.invNo">{{data.invNo}}</span>
              </td>
              <td> <span >运营策略</span></td>
              <td>{{res.virtualStrategy}}</td>
            </tr>
          </table>
        </div>
      </div> -->

            <div class="group">
                <h1 class="title">基础信息</h1>
                <div>
                    <table cellspacing="0" cellpadding="0" style="width: 100%">
                        <tr>
                            <td>ICCID</td>
                            <td>{{ iccidMark }}</td>
                            <td>接入号</td>
                            <td>{{ data.phone }}</td>
                            <td>短号</td>
                            <td>{{ res.shortIccid }}</td>
                            <td>IMEI</td>
                            <td>
                                <span v-if="data.imei">{{ data.imei }}</span>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td>MAC</td>
                            <td>
                                <span v-if="data.mac">{{ data.mac }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>二次认证时间</td>
                            <td>
                                <span v-if="data.twoAuthTime">{{
                                    data.twoAuthTime
                                }}</span>
                                <span v-else>-</span>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>套餐类型</td>
                            <td>{{ data.mealTypeStr }}</td>
                            <td>过期时间</td>
                            <td>{{ data.expireDate }}</td>
                            <td>运营商</td>
                            <td>{{ data.accountName }}</td>
                            <td>网卡状态</td>
                            <td>{{ data.statusString }}</td>
                        </tr>
                        <tr>
                            <td>代理商</td>
                            <td>
                                <span v-if="data.agentName">{{
                                    data.agentThreeName
                                }}</span>
                                <span v-else>未分配</span>
                            </td>
                            <td>供应商</td>
                            <td>{{ accountEntity.supplier }}</td>
                            <td>导入时间</td>
                            <td>{{ importTime }}</td>
                            <td>激活时间</td>
                            <td>
                                <span v-if="data.servCreateDate">
                                    {{ data.servCreateDate }}</span
                                >
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td>套餐生效时间</td>
                            <td>{{ res.takeEffectTime }}</td>
                            <td>卡类型</td>
                            <td>
                                <span v-if="data.type == 1">包月</span>
                                <span v-else>包年</span>
                            </td>
                            <td>绑定手机</td>
                            <td>
                                <span v-if="res.phonebind">{{
                                    res.phonebind
                                }}</span>
                                <span v-else>未绑定</span>
                            </td>
                            <td>流量池</td>
                            <td>
                                <span v-if="accountEntity.flowPool">{{
                                    accountEntity.flowPool
                                }}</span>
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td>运营商状态</td>
                            <td>
                                <span v-if="yunyingstatusspan">{{
                                    yunyingstatusspan
                                }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>当前限速值</td>
                            <td>{{ res.limitSpeed }}</td>
                            <td>实名状态</td>
                            <td>
                                <span v-if="isReal == 1">已实名</span>
                                <span v-else-if="isReal == 2">未实名</span>
                                <span v-else>—未知状态—</span>
                                <el-button
                                    icon="el-icon-refresh-right"
                                    type="primary"
                                    class="themed-button"
                                    @click="_isRealName"
                                    style="margin-left: 3px"
                                ></el-button>
                            </td>
                            <td>
                                <span
                                    v-if="data.toType == _getToTypeValue('Y_')"
                                    >话费</span
                                >
                                <span v-else></span>
                            </td>
                            <td>
                                <span
                                    v-if="data.toType == _getToTypeValue('Y_')"
                                    >{{ data.balanceMoney }}</span
                                >
                                <span v-else></span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span v-if="data.invNo">虚拟号</span>
                            </td>
                            <td>
                                <span v-if="data.invNo">{{ data.invNo }}</span>
                            </td>
                            <td><span>运营策略</span></td>
                            <td>{{ res.virtualStrategy }}</td>
                            <td>是否轮询</td>
                            <td>
                                <span v-if="res.noLoop">
                                    不在轮询中<span>
                                        {{ "(" + addSource + ")" }}</span
                                    ></span
                                >
                                <span v-else>轮询中</span>
                            </td>
                            <td>上次轮询时间</td>
                            <td>
                                <span v-if="res.lastLoopTime">
                                    {{ formatTime(res.lastLoopTime) }}</span
                                >
                                <span v-else>-</span>
                            </td>
                        </tr>
                        <tr>
                            <td>实名方式</td>
                            <td>
                                {{
                                    getRealNameType(accountEntity.realNameType)
                                }}
                            </td>
                            <td>首次充值时间</td>
                            <td>
                                <span v-if="data.enabledTime">{{
                                    data.enabledTime
                                }}</span>
                                <span v-else>-</span>
                            </td>
                            <td>提前停机</td>
                            <td>
                                <span v-if="stopAheadDays != 0">{{
                                    stopAheadDays + "天"
                                }}</span>

                                <span v-else>—</span>
                                <el-button
                                    icon="el-icon-refresh-right"
                                    type="primary"
                                    class="themed-button"
                                    @click="getStopAheadDaysInfo"
                                    style="margin-left: 3px"
                                ></el-button>
                                <!-- <i class="el-icon-refresh-right" @click="_isRealName"></i> -->
                            </td>
                            <td v-if="res && res.flowType">流量类型</td>
                            <td v-if="res && res.flowType">
                                {{ res.flowType }}
                            </td>
                        </tr>
                        <tr>
                            <td>无线上网定向管控</td>
                            <td>
                                <span>{{
                                    formatWirelessControlStatus(directedControl)
                                }}</span>
                                <el-button
                                    icon="el-icon-refresh-right"
                                    type="primary"
                                    class="themed-button"
                                    @click="refreshWirelessControlStatus"
                                    style="margin-left: 3px"
                                ></el-button>
                            </td>
                            <td>无线上网限速管控</td>
                            <td>
                                <span>{{
                                    formatWirelessControlStatus(speedLimitControl)
                                }}</span>
                                <el-button
                                    icon="el-icon-refresh-right"
                                    type="primary"
                                    class="themed-button"
                                    @click="refreshWirelessControlStatus"
                                    style="margin-left: 3px"
                                ></el-button>
                            </td>
                        </tr>
                        <tr>
                            <td v-if="res && res.province">归属省份</td>
                            <td v-if="res && res.province">
                                {{ res.province }}
                            </td>
                            <td v-if="res && res.switchPriority">切卡策略</td>
                            <td v-if="res && res.switchPriority">
                                {{ res.switchPriority }}
                            </td>

                            <td
                                v-if="
                                    res && typeof res.limitOneCard === 'boolean'
                                "
                            >
                                写卡限制状态
                            </td>
                            <td
                                v-if="
                                    res && typeof res.limitOneCard === 'boolean'
                                "
                            >
                                <span v-if="res.limitOneCard"> 限制 </span>
                                <span v-else-if="!res.limitOneCard"
                                    >不限制</span
                                >

                                <!-- <el-button  v-if="res.limitOneCard" type="primary" class="themed-button"  @click="unlimitCard" style="margin-left:3px">解除限制</el-button>
                   <el-button  v-if="!res.limitOneCard" type="primary" class="themed-button"  @click="limitCard" style="margin-left:3px">限制</el-button> -->
                            </td>
                            <td>备注</td>
                            <td>
                                <span v-if="res && res.remark">{{
                                    res.remark
                                }}</span>
                                <span v-else>-</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="group">
                <h1 class="title">流量信息</h1>
                <div>
                    <table cellspacing="0" cellpadding="0" style="width: 100%">
                        <tr>
                            <td>套餐总流量</td>
                            <td>{{ totalFlowId }}</td>
                            <td>已使用流量</td>
                            <td>
                                {{
                                    parseFloat(data.totalBytesCnt).toFixed(2)
                                }}MB
                            </td>
                            <td>
                                <span v-if="!data.invNo">剩余流量</span>
                            </td>
                            <td>
                                <span v-if="!data.invNo">{{
                                    surplusFlowId
                                }}</span>
                            </td>
                            <td>基础套餐</td>
                            <td>{{ data.setMealName }}</td>
                        </tr>
                        <tr v-if="isShow">
                            <td>总语音(分钟)</td>
                            <td>
                                <span>{{ data.voiceSize }}分钟</span>
                            </td>
                            <td>已使用语音(分钟)</td>
                            <td>
                                <span>{{ voiceUsed }}</span>
                            </td>
                            <td>剩余语音(分钟)</td>
                            <td>
                                <span>{{ voiceRemaining }}</span>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>
                                增加已使用流量百分比<span
                                    v-if="res.strategyType == 1"
                                >
                                    (A)</span
                                ><span v-else-if="res.strategyType == 2">
                                    (B)</span
                                >
                            </td>
                            <td>
                                <span v-html="curStrategyFormat"></span>
                            </td>
                            <td>已使用流量（真）</td>
                            <td>
                                {{
                                    parseFloat(data.orginTotalBytesCnt).toFixed(
                                        2
                                    )
                                }}MB
                            </td>
                            <td>
                                <span v-if="isShow">增加已使用语音百分比</span>
                            </td>
                            <td>
                                <span v-if="isShow">
                                    <span v-if="res.voiceAddDiscount">{{
                                        res.voiceAddDiscount
                                    }}</span>
                                    <span v-else>未设置</span>
                                </span>
                            </td>
                            <td><span v-if="isShow">已使用语音(真)</span></td>
                            <td>
                                <span v-if="isShow">{{ origVoiceUsed }}</span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="group">
                <h1 class="title">当前套餐</h1>
                <div>
                    <table cellspacing="0" cellpadding="0" style="width: 100%">
                        <tr>
                            <!-- <td v-html="currentMeal"></td> -->
                            <td>
                                <p>当前生效套餐：</p>
                                <span v-html="currentMeal"></span>
                                <p>待生效套餐：</p>
                                <span v-html="willMeal"></span>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="group" v-if="currentRole == 0 || isVir">
                <h1 class="title">常规操作</h1>
                <div>
                    <ul class="clearfix">
                        <li @click="mealRecharge" v-show="!data.invNo">
                            <img src="./1.png" alt="" />
                            <p>套餐充值</p>
                        </li>
                        <li @click="cardRecovery">
                            <img src="./3.png" alt="" />
                            <p>保号复机</p>
                        </li>
                        <li @click="cardStop">
                            <img src="./4.png" alt="" />
                            <p>保号停机</p>
                        </li>
                        <li @click="flowDetail">
                            <img src="./4.png" alt="" />
                            <p>流量详单</p>
                        </li>
                        <li @click="updateExpire">
                            <img src="./5.png" alt="" />
                            <p>更改过期时间</p>
                        </li>
                        <li @click="stopRecoveryRecord">
                            <img src="./9.png" alt="" />
                            <p>停复机记录</p>
                        </li>
                        <li @click="orderRecord">
                            <img src="./9.png" alt="" />
                            <p>往期订单</p>
                        </li>
                        <li @click="noLoopcard">
                            <img src="./7.png" alt="" />
                            <p>不轮询网卡</p>
                        </li>
                        <li @click="modifyFlow">
                            <img src="./7.png" alt="" />
                            <p>增减流量</p>
                        </li>
                        <li @click="delOnlyLoop" v-show="data.invNo">
                            <img src="./7.png" alt="" />
                            <p>删除仅轮询</p>
                        </li>
                        <li @click="returnToZero">
                            <img src="./7.png" alt="" />
                            <p>退货清零</p>
                        </li>
                        <li @click="clearPluginCards">
                            <img src="./8.png" alt="" />
                            <p>清除插拔卡</p>
                        </li>
                        <li @click="singleLimit">
                            <img src="./2.png" alt="" />
                            <p>单卡限速</p>
                        </li>
                        <li @click="cancelDxDiscon">
                            <img src="./4.png" alt="" />
                            <p>取消单独断网</p>
                        </li>
                        <li @click="clearStopRecord" v-if="currentRole == 0">
                            <img src="./6.png" alt="" />
                            <p>清除停机记录</p>
                        </li>

                        <li @click="toNewCard">
                            <img src="./7.png" alt="" />
                            <p>转新卡</p>
                        </li>
                        <li @click="advanceLife">
                            <img src="./4.png" alt="" />
                            <p>套餐提前生效</p>
                        </li>
                        <li
                            @click="modify"
                            v-if="
                                currentRole == 0 &&
                                data.balance !== undefined &&
                                data.balance !== null &&
                                data.balance !== ''
                            "
                        >
                            <img src="./6.png" alt="" />
                            <p>钱包余额</p>
                        </li>
                        <li @click="unbindRealName">
                            <img src="./4.png" alt="" />
                            <p>实名解绑</p>
                        </li>
                        <li @click="modifyAuth">
                            <img src="./6.png" alt="" />
                            <p>修改认证状态</p>
                        </li>
                        <li @click="usurpCardSetting">
                            <img src="./6.png" alt="" />
                            <p>窜卡</p>
                        </li>
                        <li @click="tamperRecovery">
                            <img src="./7.png" alt="" />
                            <p>窜卡复机</p>
                        </li>
                        <li @click="changeVirtual">
                            <img src="./2.png" alt="" />
                            <p>切换量级级别</p>
                        </li>
                        <li @click="remarkDetail">
                            <img src="./7.png" alt="" />
                            <p>备注</p>
                        </li>
                    </ul>
                </div>
            </div>
            <el-dialog
                title="修改钱包余额"
                :visible.sync="dialogModifyVisible"
                :destroy-on-close="true"
            >
                <el-form :model="modifyForm">
                    <el-form-item label="当前余额:" label-width="100px">
                        <el-input
                            :value="data.balance"
                            readonly
                            disabled
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="方式:" label-width="100px">
                        <el-select v-model="modifyForm.type">
                            <el-option label="增加" value="1"></el-option>
                            <el-option label="扣减" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="金额:" label-width="100px">
                        <el-input
                            v-model="modifyForm.money"
                            autocomplete="off"
                            style="width: 200px"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        class="themed-button"
                        type="info"
                        @click="dialogModifyVisible = false"
                        >取 消</el-button
                    >
                    <el-button
                        class="themed-button"
                        type="primary"
                        @click="sureModify"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>

            <el-dialog
                title="实名解绑"
                :visible.sync="dialogUnbind"
                v-if="dialogUnbind"
            >
                <el-form
                    v-model="formUnbind"
                    label-position="right"
                    label-width="100px"
                >
                    <el-form-item label="身份证号:" required>
                        <el-input
                            type="text"
                            placeholder="请输入身份证号码"
                            v-model="formUnbind.certId"
                            maxlength="18"
                            style="width: 80%"
                            show-word-limit
                        >
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="align-right">
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="sureUnbind"
                        >确定</el-button
                    >
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="dialogUnbind = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>

            <el-dialog
                title="修改认证状态"
                :visible.sync="dialogModifyAuth"
                :destroy-on-close="true"
                width="30%"
            >
                <el-form :model="modifyAuthForm">
                    <el-form-item label="是否认证:">
                        <el-select
                            v-model="modifyAuthForm.isAuth"
                            placeholder="请选择是否认证"
                        >
                            <el-option label="否" value="1"></el-option>
                            <el-option label="是" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        class="themed-button"
                        type="info"
                        @click="dialogModifyAuth = false"
                        >取 消</el-button
                    >
                    <el-button
                        class="themed-button"
                        type="primary"
                        @click="sureModifyAuth"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>

            <el-dialog
                title="套餐充值"
                :visible.sync="dialogAddPackage"
                v-if="dialogAddPackage"
            >
                <add-package
                    :addPackageData="addPackageData"
                    :curInfor="data"
                    @close="dialogAddPackage = false"
                ></add-package>
            </el-dialog>
            <el-dialog
                title="流量详单"
                :visible.sync="dialogFlowDetail"
                v-if="dialogFlowDetail"
            >
                <flow-detail :iccidMark="iccidMark"></flow-detail>
            </el-dialog>
            <el-dialog
                title="变更过期时间"
                :visible.sync="dialogUpdateExpire"
                v-if="dialogUpdateExpire"
                width="80%"
            >
                <update-expire
                    :cardId="cardId"
                    :iccidMark="iccidMark"
                    @refresh="refresh"
                ></update-expire>
            </el-dialog>
            <el-dialog
                title="增减流量"
                :visible.sync="dialogModifyFlow"
                v-if="dialogModifyFlow"
            >
                <change-flow
                    :curInfor="data"
                    @close="dialogModifyFlow = false"
                ></change-flow>
            </el-dialog>
            <el-dialog
                title="单卡限速"
                :visible.sync="dialogSingleSpeed"
                v-if="dialogSingleSpeed"
            >
                <single-Speed
                    :iccidMark="iccidMark"
                    @close="dialogSingleSpeed = false"
                ></single-Speed>
            </el-dialog>

            <el-dialog
                title="切换量级级别"
                :visible.sync="dialogSwitch"
                v-if="dialogSwitch"
            >
                <el-form
                    label-position="right"
                    label-width="100px"
                    v-loading="switchLoading"
                >
                    <el-form-item label="虚量选择:" required>
                        <el-radio-group v-model="strategyType">
                            <el-radio
                                v-for="(item, index) in w_defaultStrategy"
                                :key="index"
                                :label="item.dictValue"
                                >{{ item.groupName }}</el-radio
                            >
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="align-right">
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="sureSwitch"
                        >确定</el-button
                    >
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="dialogSwitch = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>

            <el-dialog
                title="清除插拔卡"
                :visible.sync="dialogClearVisible"
                v-if="dialogClearVisible"
            >
                <el-form :model="clearform">
                    <el-form-item label="插拔卡号" label-width="120px">
                        <el-checkbox-group v-model="clearform.iccids">
                            <el-checkbox
                                v-for="(item, index) in chabaList"
                                :label="item"
                                :key="index"
                                >{{ item }}</el-checkbox
                            >
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogClearVisible = false"
                        >取 消</el-button
                    >
                    <el-button type="primary" @click="clearSure"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
            <el-dialog
                title="转新卡"
                :visible.sync="dialogToNewCard"
                v-if="dialogToNewCard"
            >
                <tonew-card
                    :iccidMark="iccidMark"
                    @close="dialogToNewCard = false"
                ></tonew-card>
            </el-dialog>

            <el-dialog
                title="备注"
                :visible.sync="dialogRemark"
                v-if="dialogRemark"
            >
                <el-form
                    v-model="formRemark"
                    label-position="right"
                    label-width="100px"
                >
                    <el-form-item label="ICCID:" required>
                        <el-input
                            readonly
                            v-model="formRemark.iccidMark"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="备注:" required>
                        <el-input
                            type="textarea"
                            autosize
                            v-model="formRemark.remark"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <div class="align-right">
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="sureRemark"
                        >确定</el-button
                    >
                    <el-button
                        type="primary"
                        class="themed-button"
                        @click="dialogRemark = false"
                        >取消</el-button
                    >
                </div>
            </el-dialog>
        </div>
    </transition>
</template>

<script type="text/ecmascript-6">
import AddPackage from "./virtualCardDetail/addPackage";
import FlowDetail from "./virtualCardDetail/flowDetail";
import UpdateExpire from "./virtualCardDetail/updateExpire";
import ChangeFlow from "./virtualCardDetail/changeFlow";
import TonewCard from "./virtualCardDetail/toNewCard";
import {
    clearChaba,
    changeVirtualStrategy,
    findCardInfo,
    getPackageAll,
    activate_,
    cardRecovery_,
    cardStop_,
    limitStopRecovery_,
    setThreshold_,
    deviceCardBound_,
    tamperRecovery_,
    noLoopcard_,
    allowRealname_,
    openVoice_,
    delOnlyLoop_,
    isRealName,
    statusModify,
    cardRemarkUpdate,
    getRemarkByIccid,
    findSingleCardStopByIccid,
    returnToZero,
    clearPluginCards,
    getStopAheadDays,
    refreshControlStatus,
    clearStopRecord,
    mealAdvanceLife,
    insertUnlimitTip,
    insertLimitTip,
    singleUsurpCard,
    refreshLiuliang,
    updateAuth,
    unboundRealName,
    cancelDxDisconnected,
} from "@/api/cardManagement/cardBillDetail.js";

import {
    findInvCardInfo,
    findInvCardInfoForAgent,
} from "@/api/virtualCard/accountRateList.js";

import { writeCardOne } from "@/api/writeCardManagement/writeCardApplyList.js";
import { balanceModify } from "@/api/cardManagement/balanceManagement.js";
import { messageBox, confirmBox } from "@/utils/common.js";
import loading from "@/utils/Loading.js";
import { mapGetters, mapMutations } from "vuex";
import dictGroup from "@/mixins/dictGroup.js";
import SingleSpeed from "@/views/cardManagement/cardBillDetail/singleSpeed.vue";
import Utils from "@/utils/utils.js";
export default {
    name: "virtualCardDetail",
    mixins: [dictGroup],
    data() {
        return {
            dialogRemark: false,
            formRemark: {
                iccidMark: "",
                remark: "",
            },
            dialogClearVisible: false,
            chabaList: [],
            clearform: {
                iccids: [],
                virtualIccid: "",
            },
            isVir: false,
            fullscreenLoading: false,
            res: {},
            data: {},
            accountEntity: [],
            cardLiftList: [],
            nextCardLifeList: [],
            tianDjbCardLifes: [],

            dialogAddPackage: false,
            addPackageData: {},
            dialogFlowDetail: false,
            dialogUpdateExpire: false,
            dialogModifyFlow: false,
            strategyType: "1",
            isReal: 0,
            totalFlowId: "",
            surplusFlowId: "",
            dialogSingleSpeed: false,
            addSource: "",
            stopAheadDays: 0,
            directedControl: null,
            speedLimitControl: null,
            dialogToNewCard: false,
            dialogSwitch: false,
            switchLoading: false,

            // 写号相关数据
            cardWriteList: [],
            firstCardProvince: "",
            dialogModifyVisible: false,
            modifyForm: {
                type: "2",
                money: "",
            },
            // 实名解绑
            dialogUnbind: false,
            formUnbind: {
                iccid: "",
                certId: "",
            },
            // 修改认证状态相关
            dialogModifyAuth: false,
            modifyAuthForm: {
                iccidMark: "",
                isAuth: "",
            },
        };
    },
    computed: {
        ...mapGetters(["iccidOrPhone_v", "currentRole"]),

        curStrategyFormat() {
            let curStrategy = this.res.curStrategy;
            if (curStrategy && curStrategy !== "") {
                if (isNaN(curStrategy)) {
                    var addStr = "";
                    var pairs = curStrategy.split(";");
                    var last = 0;
                    var idx = 0;
                    var total_count = pairs.length;
                    for (var pair of pairs) {
                        idx = idx + 1;
                        var arr = pair.split(",");
                        if (idx === total_count && arr[0] < 100) {
                            addStr =
                                addStr + last + "%以上增加" + arr[1] + "%;<br>";
                        } else {
                            addStr =
                                addStr +
                                last +
                                "% ~ " +
                                arr[0] +
                                "%部分增加" +
                                arr[1] +
                                "%;<br>";
                        }
                        last = arr[0];
                    }
                    return addStr;
                } else {
                    return curStrategy + "%";
                }
            } else {
                return "未设置";
            }
        },
        isShow() {
            if (
                this.data.accountName &&
                (this.data.accountName.startsWith("常州移动") ||
                    this.data.accountName.startsWith("重庆移动"))
            ) {
                return false;
            } else {
                return true;
            }
        },
        yunyingstatusspan() {
            let flag = false;
            this.w_ACCOUNT_.forEach((item) => {
                if (item.dictValue == this.data.category) {
                    flag = true;
                }
            });
            return flag ? this.data.vendorStatus : "";
        },
        voiceRemaining() {
            return (
                (
                    this.data.voiceSize - parseInt(this.data.totalBytesCntVoice)
                ).toFixed(0) + "分钟"
            );
        },
        voiceUsed() {
            let flowCnt_voice = parseInt(this.data.totalBytesCntVoice);
            if (flowCnt_voice && flowCnt_voice != "") {
                flowCnt_voice = parseFloat(flowCnt_voice).toFixed(0);
            }
            return flowCnt_voice + "分钟";
        },
        origVoiceUsed() {
            let orginTotalBytesCntVoice = this.data.orginTotalBytesCntVoice;
            if (orginTotalBytesCntVoice && orginTotalBytesCntVoice != "") {
                orginTotalBytesCntVoice = parseFloat(
                    orginTotalBytesCntVoice
                ).toFixed(0);
            }
            return orginTotalBytesCntVoice + "分钟";
        },
        importTime() {
            //导入时间
            let createDateTime = this.data.createDateTime + "";
            return (
                createDateTime.substr(0, 4) +
                "-" +
                createDateTime.substr(4, 2) +
                "-" +
                createDateTime.substr(6, 2) +
                " " +
                createDateTime.substr(8, 2) +
                ":" +
                createDateTime.substr(8, 2) +
                ":" +
                createDateTime.substr(10, 2) +
                ":" +
                createDateTime.substr(12, 2)
            );
        },
        willMeal() {
            console.log(this.cardLiftList, this.nextCardLifeList);
            let msg = "";
            if (this.cardLiftList.length > 0) {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let currentDate = year + "/" + month + "/" + day;
                let currentDate_unix = Date.parse(currentDate);
                this.cardLiftList.forEach((item) => {
                    let compareDate = "";
                    let compareDate_unix = "";
                    if (item.startDate) {
                        compareDate = item.startDate
                            .substring(0, 10)
                            .replace(/\-/g, "/");
                        compareDate_unix = Date.parse(compareDate);
                    }
                    if (currentDate_unix < compareDate_unix) {
                        let effictDate = "";
                        if (item.startDate || item.expireDate) {
                            effictDate =
                                item.startDate.substring(0, 10) +
                                "至" +
                                item.expireDate.substring(0, 10);
                        } else {
                            effictDate = "-";
                        }
                        msg +=
                            item.mealName +
                            "&nbsp;&nbsp;&nbsp; <strong>有效周期:</strong> " +
                            effictDate +
                            "&nbsp;&nbsp;&nbsp; <strong>容量: </strong> " +
                            item.flowSize +
                            "MB " +
                            item.voiceSize +
                            "分钟<br>";
                    }
                });
            }

            if (this.nextCardLifeList.length > 0) {
                //  msg+="待生效套餐<br>"
                this.nextCardLifeList.forEach((item) => {
                    msg +=
                        item.mealName +
                        " " +
                        "(次月生效) " +
                        "&nbsp;&nbsp;&nbsp; <strong>容量: </strong> " +
                        item.flowSize +
                        "MB" +
                        "<br/>";
                });
            }
            if (this.tianDjbCardLifes.length > 0) {
                this.tianDjbCardLifes.forEach((item) => {
                    msg +=
                        item.mealName +
                        " " +
                        "(次月生效) " +
                        "&nbsp;&nbsp;&nbsp; <strong>容量: </strong> " +
                        item.flowSize +
                        "MB" +
                        "<br/>";
                });
            }

            return msg;
        },
        currentMeal() {
            //当前套餐
            console.log(this.cardLiftList, this.nextCardLifeList);
            let msg = "";
            if (this.cardLiftList.length > 0) {
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let currentDate = year + "/" + month + "/" + day;
                let currentDate_unix = Date.parse(currentDate);
                this.cardLiftList.forEach((item) => {
                    let compareDate = "";
                    let compareDate_unix = "";
                    if (item.startDate) {
                        compareDate = item.startDate
                            .substring(0, 10)
                            .replace(/\-/g, "/");
                        compareDate_unix = Date.parse(compareDate);
                    }
                    if (currentDate_unix >= compareDate_unix) {
                        let effictDate = "";
                        if (item.startDate || item.expireDate) {
                            effictDate =
                                item.startDate.substring(0, 10) +
                                "至" +
                                item.expireDate.substring(0, 10);
                        } else {
                            effictDate = "-";
                        }
                        msg +=
                            item.mealName +
                            "&nbsp;&nbsp;&nbsp; <strong>有效周期:</strong> " +
                            effictDate +
                            "&nbsp;&nbsp;&nbsp; <strong>容量: </strong> " +
                            item.flowSize +
                            "MB " +
                            item.voiceSize +
                            "分钟<br>";
                    }
                });
            }

            return msg;
        },
        gparams() {
            let params = {};
            params.iccidOrPhone = this.iccidMark;
            params.setMealId = this.data.setMealId;
            params.isChild = this.data.isChild;
            params.codeChild = this.data.codeChild;
            params.cardType = this.data.category;
            params.status = this.data.status;
            params.type = this.data.type;
            return params;
        },
        iccidMark() {
            let params = this.$route.query;
            let iccidMark = params.iccidOrPhone;
            if (!params.iccidOrPhone) {
                iccidMark = this.iccidOrPhone_v;
            }

            return iccidMark;
        },
        cardId() {
            return this.data.id;
        },
        showWriteCardButton() {
            // 判断是否显示写号推送按钮
            // 条件：firstCardProvince存在 且 cardWriteList数组存在且长度为1
            return (
                this.firstCardProvince &&
                this.cardWriteList &&
                this.cardWriteList.length === 1
            );
        },
    },
    mounted() {
        this.fullscreenLoading = true;
        this._findInvCardInfo();
        this.refreshWirelessControlStatus(false);
    },
    methods: {
        sureRemark() {
            if (this.formRemark.remark == "") {
                messageBox(this, "备注不能为空");
                return;
            }
            if (this.formRemark.remark.length > 150) {
                messageBox(this, "备注最大长度不能超过150字符");
                return;
            }
            cardRemarkUpdate(this.formRemark).then((res) => {
                messageBox(this, "修改成功");
                this.dialogRemark = false;
                this._findInvCardInfo();
            });
        },
        remarkDetail() {
            //备注
            this.dialogRemark = true;
            this.formRemark.iccidMark = this.iccidMark;
            this.formRemark.remark = this.res.remark;
        },

        changeVirtual() {
            this.dialogSwitch = true;
        },
        sureSwitch() {
            if (this.strategyType == this.res.strategyType + "") {
                this.dialogSwitch = false;
                return;
            }
            const params = {
                iccidMark: this.iccidMark,
                strategyType: this.strategyType,
            };
            this.switchLoading = true;
            changeVirtualStrategy(params)
                .then(() => {
                    this.dialogSwitch = false;
                    this.switchLoading = false;
                    messageBox(this, "切换虚量成功");
                    this._findInvCardInfo();
                })
                .catch(() => {
                    this.switchLoading = false;
                    this.dialogSwitch = false;
                });
        },

        usurpCardSetting() {
            let params = {
                iccidMark: this.iccidMark,
            };
            singleUsurpCard(params).then((res) => {
                messageBox(this, "操作成功");
                this._findInvCardInfo();
            });
        },
        tamperRecovery() {
            // 窜卡复机
            this.fullscreenLoading = true;
            tamperRecovery_(this.gparams)
                .then((res) => {
                    if (res.system_result_message_key) {
                        messageBox(this, res.system_result_message_key);
                    }
                    this._findInvCardInfo();
                    this.fullscreenLoading = false;
                })
                .catch(() => {
                    this.fullscreenLoading = false;
                });
        },
        modify() {
            this.dialogModifyVisible = true;
            this.modifyForm.type = "2";
            this.modifyForm.money = "";
        },

        // 修改认证状态
        modifyAuth() {
            this.dialogModifyAuth = true;
            this.modifyAuthForm.iccidMark = this.iccidMark;
            this.modifyAuthForm.isAuth = (this.data.isAuth || "") + "";
        },

        sureModifyAuth() {
            if (this.modifyAuthForm.isAuth === "") {
                messageBox(this, "请选择是否认证！");
                return;
            }
            updateAuth({
                iccidMark: this.modifyAuthForm.iccidMark,
                isAuth: this.modifyAuthForm.isAuth,
            })
                .then((res) => {
                    if (res.system_result_key == 0) {
                        this.$message({
                            showClose: true,
                            message: "修改成功",
                            type: "success",
                        });
                        this.dialogModifyAuth = false;
                        this._findInvCardInfo();
                    } else {
                        this.$message({
                            showClose: true,
                            message:
                                res.system_result_message_key || "修改失败",
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "修改失败",
                        type: "error",
                    });
                });
        },

        // 取消单独断网
        cancelDxDiscon() {
            cancelDxDisconnected({ iccidMark: this.iccidMark }).then((res) => {
                messageBox(this, "操作成功!");
                this._findInvCardInfo();
            });
        },

        // 实名解绑
        unbindRealName() {
            if (this.accountEntity.platformCode === "mobilePboss") {
                this.dialogUnbind = true;
                this.formUnbind.iccid = this.iccidMark;
                this.formUnbind.certId = "";
            } else {
                unboundRealName({ iccid: this.iccidMark }).then((res) => {
                    messageBox(this, "操作成功!");
                    this._findInvCardInfo();
                });
            }
        },
        sureUnbind() {
            if (this.formUnbind.certId.trim() === "") {
                messageBox(this, "身份证号码不能为空");
                return;
            }
            if (
                !(
                    this.formUnbind.certId.length === 18 ||
                    this.formUnbind.certId.length === 15
                )
            ) {
                messageBox(this, "身份证号码位数不对");
                return;
            }
            unboundRealName(this.formUnbind).then((res) => {
                messageBox(this, "操作成功!");
                this._findInvCardInfo();
                this.dialogUnbind = false;
            });
        },

        sureModify() {
            if (this.modifyForm.type == "") {
                messageBox(this, "请选择修改方式！");
                return;
            }
            if (isNaN(this.modifyForm.money)) {
                messageBox(this, "请输入正确的金额！");
                return;
            }
            if (
                !!this.modifyForm.money &&
                this.modifyForm.type == "2" &&
                parseFloat(this.modifyForm.money) >
                    parseFloat(this.data.balance)
            ) {
                this.$alert("扣减金额不大于剩余金额", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            if (
                !!this.modifyForm.money &&
                this.modifyForm.type == "1" &&
                parseFloat(this.modifyForm.money) > 1000
            ) {
                this.$alert("增加金额不大于1000", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            Object.assign(this.modifyForm, { iccid: this.iccidMark });
            balanceModify(this.modifyForm).then((res) => {
                if (res.system_result_key == 0) {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success",
                    });
                    this.dialogModifyVisible = false;
                    this._findInvCardInfo();
                } else {
                }
            });
        },

        advanceLife() {
            //套餐提前生效
            mealAdvanceLife({ iccidMark: this.iccidMark }).then((res) => {
                messageBox(this, "操作成功!");
                this._findInvCardInfo();
            });
        },
        toNewCard() {
            //转新卡
            this.dialogToNewCard = true;
        },

        handleIccids(val) {
            console.log(val);
        },
        clearSure() {
            console.log(this.clearform);
            if (this.clearform.iccids.length == 0) {
                messageBox(this, "请选择插拔卡");
                return;
            }
            let params = {
                iccids: this.clearform.iccids.join(","),
                virtualIccid: this.clearform.virtualIccid,
            };
            clearChaba(params).then((res) => {
                this.dialogClearVisible = false;
                this.$message({
                    showClose: true,
                    message: "清除插拔卡成功",
                    type: "success",
                });
            });
        },
        ...mapMutations(["SET_ICCID_FOR_TFJ"]),
        getStopAheadDaysInfo() {
            getStopAheadDays({ iccid: this.iccidMark }).then((res) => {
                console.log(res);
                this.stopAheadDays = res.stopAheadDays;
            });
        },
        formatWirelessControlStatus(val) {
            if (val === null || val === undefined) {
                return "-";
            }
            if (val === true || val === "true" || val === 1 || val === "1") {
                return "是";
            }
            if (val === false || val === "false" || val === 0 || val === "0") {
                return "否";
            }
            return "-";
        },
        refreshWirelessControlStatus(reloadPage = true) {
            refreshControlStatus({ iccid: this.iccidMark })
                .then((res) => {
                    if (
                        res.system_result_key == "0" ||
                        res.code == "0" ||
                        res.app_result_key == "0"
                    ) {
                        if (res.directedControl !== undefined) {
                            this.directedControl = res.directedControl;
                        }
                        if (res.speedLimitControl !== undefined) {
                            this.speedLimitControl = res.speedLimitControl;
                        }
                        if (reloadPage) {
                            this.refresh(true);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key || "刷新失败",
                            type: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$message({
                        showClose: true,
                        message: "刷新失败",
                        type: "error",
                    });
                });
        },
        refreshLiuliang() {
            this.fullscreenLoading = true;
            refreshLiuliang({ iccid: this.iccidMark })
                .then((res) => {
                    this.fullscreenLoading = false;
                    if (res.system_result_key == "0") {
                        messageBox(this, "刷新成功");
                        this._findInvCardInfo();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: "error",
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fullscreenLoading = false;
                });
        },
        formatTime(time) {
            return Utils.dateFormat("YYYY-mm-dd HH:MM:SS", new Date(time));
        },
        getRealNameType(realNameType) {
            console.log(realNameType);
            let realNameTypeStr = "-";
            if (realNameType == "4") {
                realNameTypeStr = "不用实名";
            } else if (realNameType == "1") {
                realNameTypeStr = "先实名后充值";
            } else if (realNameType == "2") {
                realNameTypeStr = "先充值后强制实名";
            } else if (realNameType == "3") {
                realNameTypeStr = "可选择下次实名";
            }
            return realNameTypeStr;
        },
        singleLimit() {
            //单卡限速
            this.dialogSingleSpeed = true;
        },
        clearStopRecord() {
            let params = {};
            params.iccidOrPhone = this.iccidMark;
            clearStopRecord(params)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        showClose: true,
                        message: "清除停机记录成功",
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.$message({
                        showClose: true,
                        message: "清除停机记录失败",
                        type: "warning",
                    });
                });
        },
        delOnlyLoop() {
            //删除仅轮询
            this.fullscreenLoading = true;
            delOnlyLoop_(this.gparams)
                .then((res) => {
                    this._findInvCardInfo();
                    this.fullscreenLoading = false;
                })
                .catch(() => {
                    this.fullscreenLoading = false;
                });
        },
        modifyFlow() {
            //增减流量
            this.dialogModifyFlow = true;
        },
        noLoopcard() {
            //不轮询网卡
            if (this.res.noLoop) {
                messageBox(this, "该卡已经是不轮询状态。");
                return;
            }
            confirmBox(
                this,
                "添加成功后该卡将不执行停复机操作同时会出现流量，状态不更新等状态，请谨慎操作！",
                "操作提示",
                this._noLoopcard_
            );
        },
        _noLoopcard_() {
            noLoopcard_(this.gparams).then((res) => {
                messageBox(this, "添加成功。");
                this._findInvCardInfo();
            });
        },
        orderRecord() {
            //往期订单
            // this.$router.push({
            //   path: "/cardManagement/orderRecord",
            //   query: {
            //     iccidMark: this.iccidMark
            //   },
            // })
            this.$router
                .push({ path: "/cardManagement/orderRecord/" + this.iccidMark })
                .catch(() => true);
        },
        stopRecoveryRecord() {
            ///停复机记录
            this.SET_ICCID_FOR_TFJ(this.iccidMark);
            this.$router.push({
                path: "/cardManagement/tingfujiRecord",
                query: {
                    iccidMark: this.iccidMark,
                },
            });
        },
        updateExpire() {
            //更改过期时间
            this.dialogUpdateExpire = true;
        },
        flowDetail() {
            //流量详单
            this.dialogFlowDetail = true;
        },
        cardStop() {
            //保号停机
            this.fullscreenLoading = true;
            cardStop_(this.gparams)
                .then((res) => {
                    this._findInvCardInfo();
                    this.fullscreenLoading = false;
                })
                .catch(() => {
                    this.fullscreenLoading = false;
                });
        },
        cardRecovery() {
            //保号复机
            this.fullscreenLoading = true;
            cardRecovery_(this.gparams)
                .then((res) => {
                    this._findInvCardInfo();
                    this.fullscreenLoading = false;
                })
                .catch(() => {
                    this.fullscreenLoading = false;
                });
        },
        compareResult(expireDate) {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let currentDate = year + "/" + month + "/" + day;
            let currentDate_unix = Date.parse(currentDate);
            let compareDate = "";
            let compareDate_unix = "";
            if (expireDate) {
                compareDate = expireDate.substring(0, 10).replace(/\-/g, "/");
                compareDate_unix = Date.parse(compareDate);
            }
            if (currentDate_unix >= compareDate_unix) {
                //当前时间大于等于过期时间   没有有效套餐
                return false;
            }
            return true;
        },
        mealRecharge() {
            //套餐充值
            if (this.res.noRecharge) {
                messageBox(this, "该卡暂不支持充值。");
                return;
            }
            if (
                this.data.expireDate != "-" &&
                this.compareResult(this.data.expireDate)
            ) {
                confirmBox(
                    this,
                    "该卡已有套餐，确认是否继续充值?",
                    "操作提示",
                    () => {
                        this._mealRecharge();
                    }
                );
            } else {
                this._mealRecharge();
            }
        },
        _isRealName() {
            isRealName({ iccidOrPhone: this.iccidMark }).then((res) => {
                if (res.isRealName == false) {
                    this.isReal = 2;
                } else if (res.isRealName == true) {
                    this.isReal = 1;
                }
            });
        },
        returnToZero() {
            let params = {};
            params.iccid = this.iccidMark;
            returnToZero(params)
                .then((res) => {
                    this.$message({
                        showClose: true,
                        message: "退货清零成功",
                        type: "success",
                    });
                })
                .catch((error) => {
                    this.$message({
                        showClose: true,
                        message: "退货清零失败",
                        type: "warning",
                    });
                });
        },
        clearPluginCards() {
            let params = {};
            params.iccid = this.iccidMark;
            clearPluginCards(params)
                .then((res) => {
                    console.log(res);
                    if (res.system_result_message_key.includes("8986")) {
                        let allArr = res.system_result_message_key.split(":");
                        console.log(allArr);
                        this.clearform.virtualIccid = allArr[0];
                        let str = "";
                        if (allArr[1].endsWith(";")) {
                            str = allArr[1].slice(0, -1);
                        } else {
                            str = allArr[1];
                        }
                        this.chabaList = str.split(";");
                        this.dialogClearVisible = true;
                        //
                    } else {
                        this.$message({
                            showClose: true,
                            message: "清除插拔卡成功",
                            type: "success",
                        });
                    }
                })
                .catch((error) => {
                    //  this.$message({
                    // 			showClose: true,
                    // 			message: error,
                    //       type: 'warning',
                    // 		})
                });
        },
        refresh(type) {
            this.fullscreenLoading = true;
            this._findInvCardInfo(type);
        },
        _findInvCardInfo(type) {
            let params = this.$route.query;
            let cache;
            if (!!type) {
                cache = false; //实时获取
            } else {
                cache = true; //本地获取
            }
            if (!params.iccidOrPhone) {
                params = {
                    iccidOrPhone: this.iccidOrPhone_v,
                    cache: cache,
                };
            } else { 
                params.cache = cache;
            }
            this.isVir = params.iccidOrPhone.startsWith("8986888877");
            if (this.currentRole == 0 || this.isVir) {
                findInvCardInfo(params).then((res) => {
                    this.fullscreenLoading = false;
                    this.res = res;
                    this.data = res.entity;
                    this.accountEntity = res.accountEntity;
                    this.cardLiftList = res.cardLiftList;
                    this.nextCardLifeList = res.nextCardLifeList;
                    this.tianDjbCardLifes = res.tianDjbCardLifes;

                    // 处理写号相关数据
                    this.cardWriteList = res.cardWriteList || [];
                    this.firstCardProvince = res.firstCardProvince || "";

                    this.strategyType = res.strategyType + "";
                    if (res.noLoop) {
                        this.addSource = res.addSource;
                    }
                    let currSetmealFlow = 0;
                    let currSetmealName = "";
                    let isLongDiKa = false;
                    if (this.cardLiftList) {
                        isLongDiKa = false;
                        if (this.cardLiftList && this.cardLiftList.length > 0) {
                            for (var i = 0; i < this.cardLiftList.length; i++) {
                                // if(isLongDiKa == false && (this.cardLiftList[i].type == 6 || this.cardLiftList[i].type == 23 )) {
                                let typeValue = this._getDictValue(
                                    "ZRLJTC_",
                                    this.w_packageType
                                );
                                if (
                                    isLongDiKa == false &&
                                    this.cardLiftList[i].type == typeValue
                                ) {
                                    isLongDiKa = true;
                                    break;
                                }
                            }
                        }
                    }
                    this.cardLiftList.forEach((item) => {
                        // if(item.type != 1 && item.type != 101){
                        if (
                            item.type !=
                                this._getDictValue(
                                    "DJB_",
                                    this.w_packageType
                                ) &&
                            item.type !=
                                this._getDictValue("YYDJB_", this.w_packageType)
                        ) {
                            currSetmealFlow = item.flowSize;
                            currSetmealName = item.mealName;
                        }
                    });

                    if (
                        currSetmealFlow == 0 &&
                        !(!isLongDiKa && this.cardLiftList)
                    ) {
                        this.surplusFlowId = "∞ MB";
                        this.totalFlowId = "∞ MB";
                    } else {
                        this.surplusFlowId =
                            parseFloat(
                                this.data.flowSize - this.data.totalBytesCnt
                            ).toFixed(2) + "MB";
                        this.totalFlowId = this.data.flowSize + "MB";
                    }
                });
            } else {
                findInvCardInfoForAgent(params).then((res) => {
                    this.fullscreenLoading = false;
                    this.res = res;
                    this.data = res.entity;
                    this.accountEntity = res.accountEntity;
                    this.cardLiftList = res.cardLiftList;
                    this.nextCardLifeList = res.nextCardLifeList;
                    this.tianDjbCardLifes = res.tianDjbCardLifes;

                    // 处理写号相关数据
                    this.cardWriteList = res.cardWriteList || [];
                    this.firstCardProvince = res.firstCardProvince || "";

                    this.strategyType = res.strategyType + "";
                    if (res.noLoop) {
                        this.addSource = res.addSource;
                    }
                    let currSetmealFlow = 0;
                    let currSetmealName = "";
                    let isLongDiKa = false;
                    if (this.cardLiftList) {
                        isLongDiKa = false;
                        if (this.cardLiftList && this.cardLiftList.length > 0) {
                            for (var i = 0; i < this.cardLiftList.length; i++) {
                                // if(isLongDiKa == false && (this.cardLiftList[i].type == 6 || this.cardLiftList[i].type == 23 )) {
                                let typeValue = this._getDictValue(
                                    "ZRLJTC_",
                                    this.w_packageType
                                );
                                if (
                                    isLongDiKa == false &&
                                    this.cardLiftList[i].type == typeValue
                                ) {
                                    isLongDiKa = true;
                                    break;
                                }
                            }
                        }
                    }
                    this.cardLiftList.forEach((item) => {
                        // if(item.type != 1 && item.type != 101){
                        if (
                            item.type !=
                                this._getDictValue(
                                    "DJB_",
                                    this.w_packageType
                                ) &&
                            item.type !=
                                this._getDictValue("YYDJB_", this.w_packageType)
                        ) {
                            currSetmealFlow = item.flowSize;
                            currSetmealName = item.mealName;
                        }
                    });

                    if (
                        currSetmealFlow == 0 &&
                        !(!isLongDiKa && this.cardLiftList)
                    ) {
                        this.surplusFlowId = "∞ MB";
                        this.totalFlowId = "∞ MB";
                    } else {
                        this.surplusFlowId =
                            parseFloat(
                                this.data.flowSize - this.data.totalBytesCnt
                            ).toFixed(2) + "MB";
                        this.totalFlowId = this.data.flowSize + "MB";
                    }
                });
            }
        },
        _mealRecharge() {
            loading.show();
            let params = {};
            params.iccidOrPhone = this.iccidMark;
            params.setMealId = this.data.setMealId;
            params.isChild = this.data.isChild;
            params.codeChild = this.data.codeChild;
            getPackageAll(params).then((res) => {
                this.dialogAddPackage = true;
                this.addPackageData = res;
            });
        },
        handleWriteCardPush() {
            // 写号推送逻辑
            if (!this.cardWriteList || this.cardWriteList.length === 0) {
                messageBox(this, "没有待写卡信息");
                return;
            }

            const writeCardInfo = this.cardWriteList[0]; // 获取第一张待写卡信息

            // 判断写号逻辑
            if (this.firstCardProvince === "全国") {
                // 若第一张卡firstCardProvince是全国
                if (!writeCardInfo.province || writeCardInfo.province === "") {
                    // 省份为空，提示去公众号获取定位
                    messageBox(this, "请去公众号获取定位");
                    let params = this.$route.query;
                    if (!params.iccidOrPhone) {
                        params = {
                            iccidOrPhone: this.iccidOrPhone_v,
                        };
                    }
                    this.callUnlimitTip(params.iccidOrPhone);
                    return;
                } else if (writeCardInfo.province === "全国") {
                    // 不为空且是全国，提示需要修改为非全国卡
                    messageBox(this, "需要修改为非全国卡，请去公众号获取定位");
                    return;
                } else {
                    // 不为空且不为全国，直接写卡
                    this.submitWriteCard(
                        writeCardInfo.iccidMark,
                        writeCardInfo.province
                    );
                }
            } else if (
                this.firstCardProvince &&
                this.firstCardProvince !== "全国"
            ) {
                // 若第一张卡firstCardProvince存在且不是全国，不判断省份，直接省份传入全国进行写卡
                this.submitWriteCard(writeCardInfo.iccidMark, "全国");
            } else {
                messageBox(this, "写号信息异常");
            }
        },

        // 提交写卡请求
        submitWriteCard(iccidMark, province) {
            this.fullscreenLoading = true;

            // 显示写号提示
            this.$confirm(
                `即将为卡号：${iccidMark}，写号省份为：${province}。是否确认继续写号操作？`,
                "写号提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    // 调用写卡接口
                    writeCardOne({
                        iccid: iccidMark,
                        province: province,
                    })
                        .then((res) => {
                            this.fullscreenLoading = false;
                            if (res.system_result_key === "0") {
                                this.$message.success(
                                    res.system_result_message_key || "写卡成功"
                                );

                                // 写号成功后调用解除限速接口
                                let params = this.$route.query;
                                if (!params.iccidOrPhone) {
                                    params = {
                                        iccidOrPhone: this.iccidOrPhone_v,
                                    };
                                }
                                this.callUnlimitTip(params.iccidOrPhone);

                                this.refresh();
                            } else {
                                this.$message.error(
                                    res.system_result_message_key || "写卡失败"
                                );
                            }
                        })
                        .catch((err) => {
                            this.fullscreenLoading = false;
                            this.$message.error("写卡失败，请稍后重试");
                            console.error(err);
                        });
                })
                .catch(() => {
                    // 用户取消操作
                    this.fullscreenLoading = false;
                });
        },

        // 调用解除限速接口
        callUnlimitTip(iccidMark) {
            insertUnlimitTip({ iccidMark: iccidMark })
                .then((res) => {
                    if (res.system_result_key === "0") {
                        this.$message.success("解除限速成功");
                    } else {
                        this.$message.warning(
                            res.system_result_message_key || "解除限速失败"
                        );
                    }
                })
                .catch((err) => {
                    console.error("解除限速失败:", err);
                    this.$message.warning("解除限速失败，请稍后重试");
                });
        },

        // 解除写卡限制
        unlimitCard() {
            this.fullscreenLoading = true;
            let params = this.$route.query;
            if (!params.iccidOrPhone) {
                params = {
                    iccidOrPhone: this.iccidOrPhone_v,
                };
            }
            insertUnlimitTip({ iccidMark: params.iccidOrPhone })
                .then((res) => {
                    this.fullscreenLoading = false;
                    if (res.system_result_key === "0") {
                        this.$message.success("解除写卡限制成功");
                        this.refresh();
                    } else {
                        this.$message.error(
                            res.system_result_message_key || "解除写卡限制失败"
                        );
                    }
                })
                .catch((err) => {
                    this.fullscreenLoading = false;
                    this.$message.error("解除写卡限制失败，请稍后重试");
                    console.error(err);
                });
        },

        // 添加写卡限制
        limitCard() {
            this.fullscreenLoading = true;
            let params = this.$route.query;
            if (!params.iccidOrPhone) {
                params = {
                    iccidOrPhone: this.iccidOrPhone_v,
                };
            }
            insertLimitTip({ iccidMark: params.iccidOrPhone })
                .then((res) => {
                    this.fullscreenLoading = false;
                    if (res.system_result_key === "0") {
                        this.$message.success("添加写卡限制成功");
                        this.refresh();
                    } else {
                        this.$message.error(
                            res.system_result_message_key || "添加写卡限制失败"
                        );
                    }
                })
                .catch((err) => {
                    this.fullscreenLoading = false;
                    this.$message.error("添加写卡限制失败，请稍后重试");
                    console.error(err);
                });
        },
    },
    components: {
        AddPackage,
        FlowDetail,
        UpdateExpire,
        ChangeFlow,
        SingleSpeed,
        TonewCard,
    },
};
</script>

<style>
ul {
    list-style: none;
}
.cardBillDetail {
    position: relative;
    width: 100%;
    /* height: 100%; */
    background: #fff;
}
.cardBillDetail .card-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    color: rgba(7, 17, 27, 0.5);
}
.cardBillDetail .card-icon i {
    font-size: 18px;
    font-weight: 700;
    margin-right: 10px;
}
.cardBillDetail .group {
    padding: 25px;
    background: #fff;
}
/* .cardBillDetail .group table {
  border-left: 1px solid #e7e7e7;
  border-top: 1px solid #e7e7e7;
} */
.cardBillDetail .group table td {
    height: 32px;
    line-height: 32px;
    /* border-right: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7; */
    text-align: left;
}
.cardBillDetail .group .title {
    height: 32px;
    line-height: 32px;
}
.cardBillDetail ul > li {
    float: left;
    width: 125px;
    text-align: center;
    margin-right: 20px;
    margin-top: 10px;
}

/* .write-card-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
  font-weight: 500;
  transition: all 0.3s ease;
}

.write-card-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
} */
</style>
